/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyEqualAnnotationKeyAnnotationValue: core.serialization.ObjectSchema<
    serializers.KeyEqualAnnotationKeyAnnotationValue.Raw,
    Truvity.KeyEqualAnnotationKeyAnnotationValue
> = core.serialization.object({
    key: core.serialization.string(),
    value: core.serialization.string(),
});

export declare namespace KeyEqualAnnotationKeyAnnotationValue {
    export interface Raw {
        key: string;
        value: string;
    }
}
